import type { SVGProps } from "react";
import * as React from "react";
const SvgCommunity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 21v-9l4-3.456V3h16v18H2Zm7-2h3v-6.058L8 9.454l-4 3.488V19h3v-4h2v4Zm5 0h6V5H8l.004 1.75L14 12v7Zm2-8h2v2h-2v-2Zm0 4h2v2h-2v-2Zm0-8h2v2h-2V7Zm-4 0h2v2h-2V7Z"
    />
  </svg>
);
export default SvgCommunity;
